export default "__VITE_ASSET__zAcArfAQ__"